export const SCANS_PAGE_REFRESH_INTERVAL_MS = 3 * 60000; // 3 minutes
